export default __webpack_public_path__ + "static/media/6.4f2aa6f2.png";